/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import EventCondition from 'cio/app-models/conditions/event';

interface ConditionEditorEventArgs {
  condition: EventCondition;
  disabled: boolean;
  size?: string;
  variation?: string;
  allowForeignEvent: boolean;
  disabledInverseOptions?: string[];
  hiddenInverseOptions?: string[];
  htmlTag?: string;
}

export default class ConditionEditorEvent extends Component<ConditionEditorEventArgs> {
  get htmlTag() {
    return this.args.htmlTag ?? '';
  }
}
